import React from 'react';
import { Typography, Box } from '@material-ui/core';
import globals from '../../globals/communityGlobals';
import TeamsAvailabilityForm from '../../containers/Dashboard/TeamAvailability/TeamAvailabilityFormContainer';
import PageContent from '../PageStructure/PageContent/PageContent';

const locale = globals.getArea('dashboard');

const Dashboard = () => (
  <PageContent pageTitle={locale.getMsg('dashboardHeader')}>
    <React.Fragment>
      <Box className="title-section" display="flex" alignItems="center" px={2} py={1}>
        <Typography variant="h3">{locale.getMsg('dashboardHeader')}</Typography>
      </Box>
      <TeamsAvailabilityForm />
    </React.Fragment>
  </PageContent>
);

export default Dashboard;
